<template>
  <div class="app-onboarding-container" :class="containerClasses">
    <aside class="left-panel">
      <slot name="left-panel" />
    </aside>

    <transition :name="transitionConfig.transition" mode="in-out" appear>
      <main class="main-panel">
        <slot name="main-panel" />
      </main>
    </transition>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import { transitionGetters } from '@/store/modules/transition/routines'

export default {
  name: 'AppOnboarding',
  props: {
    fullWidth: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    ...mapGetters({
      transitionConfig: transitionGetters.TRANSITION_CONFIG
    }),
    containerClasses() {
      return {
        'full-width': this.fullWidth
      }
    }
  }
}
</script>

<style lang="scss" scoped>
@import '@/assets/styles/swoop/_variables.scss';

.app-onboarding-container {
  height: 100vh;
  display: flex;

  .left-panel {
    width: 50vw;
    position: relative;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: space-between;
    color: $color-white;
    background-size: auto;
    z-index: 1;
  }

  .main-panel {
    width: 50vw;
  }
}

.app-onboarding-container.full-width {
  .left-panel {
    display: none;
    width: 0;
  }

  .main-panel {
    width: 100%;
    display: flex;
    justify-content: center;
    align-items: flex-start;
    padding: 24px 0;
    box-sizing: border-box;
  }
}
</style>
